import axios from 'axios'

const getAPI = axios.create({
    baseURL: 'https://uzal-api.herokuapp.com/api/', // Django Rest Framework URL
    timeout: 20000,
})

export { getAPI }